import axios from "axios";

const BASE = `${process.env.REACT_APP_BECCO_API_URL}/api/sfq-site`;

export const sfqSiteApi = {
  // Locked screen: minimal metadata + passwordProtected flag (no questions/answers).
  load: (token) => axios.get(`${BASE}/${token}`),
  // Verify the access password → returns full { inv, answers, questions }, or
  // { inv, consent, needsConsent: true } when 개인정보 동의 has not been given yet —
  // the questionnaire is withheld until it is.
  verify: (token, password) =>
    axios.post(`${BASE}/${token}/verify`, { password }),
  // Record the consent; the response is the same full payload verify would have returned.
  consent: (token, { lang }, password) =>
    axios.post(`${BASE}/${token}/consent`, { lang, password }),
  saveAnswers: (token, answers, password) =>
    axios.put(`${BASE}/${token}/answers`, { answers, password }),
  submit: (token, password) =>
    axios.post(`${BASE}/${token}/submit`, { password }),
};
